import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { transition1 } from '../transitions';

const TABS = ['All', 'Places', 'People', 'Other'];

const Portfolio = ({ data }) => {
  const [activeTab, setActiveTab] = useState('All');

  const filtered = useMemo(() => {
    if (activeTab === 'All') return data;
    return data.filter(
      (item) => item.category?.toLowerCase() === activeTab.toLowerCase()
    );
  }, [activeTab, data]);

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={transition1}
      className='section overflow-scroll relative'
    >
      <div className='px-[30px] lg:px-[100px] pt-[100px] lg:pt-[140px]'>

        {/* ── Meta row ── */}
        <div className='flex items-center gap-4 mb-8'>
          <div className='flex-1 h-px bg-[#e5e5e5]' />
          <span className='text-sm tracking-widest text-[#aaa] font-primary'>
            {filtered.length} collections
          </span>
        </div>

        {/* ── Hero text ── */}
        <p className='font-secondary font-light text-[#888] text-base leading-relaxed max-w-[30rem] mb-10'>
          A curated edit of personal work during my travels and professional work, grouped into collections by what's in front of the lens.
        </p>

        {/* ── Tabs ── */}
        <div className='flex items-end gap-8 mb-10 border-b border-[#e5e5e5]'>
          {TABS.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-3 text-xs tracking-widest uppercase font-secondary transition-all leading-none border-b-2 -mb-px ${
                activeTab === tab
                  ? 'border-primary text-primary'
                  : 'border-transparent text-[#aaa] hover:text-[#555]'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* ── Grid ── */}
        <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 auto-rows-fr lg:gap-6 gap-4 pb-16'>
          <AnimatePresence mode='popLayout'>
            {filtered.map((item) => (
              <motion.div
                key={item.id}
                layout
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.25 }}
                className='group justify-center h-full w-auto items-center relative flex-auto'
              >
                <div className='aspect-w-4 aspect-h-5 w-auto h-full overflow-hidden'>
                  <img
                    className='object-cover h-full w-full object-center transition-transform duration-500 group-hover:scale-105'
                    src={item.imgSrc}
                    alt=''
                  />
                </div>
                <Link className='cover' to={item.link}>
                  <p>{item.coverName}</p>
                </Link>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>

      </div>
    </motion.section>
  );
};

export default Portfolio;